var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clients-02",
    transform: "translate(-1500.000000, -271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_add",
    transform: "translate(1470.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E1E7F0",
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "add-circle",
    transform: "translate(10.000000, 10.000000)",
    fill: "#95C11F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,14.375 C9.655,14.375 9.375,14.095 9.375,13.75 L9.375,10.625 L6.25,10.625 C5.905,10.625 5.625,10.345 5.625,10 C5.625,9.655 5.905,9.375 6.25,9.375 L9.375,9.375 L9.375,6.25 C9.375,5.905 9.655,5.625 10,5.625 C10.345,5.625 10.625,5.905 10.625,6.25 L10.625,9.375 L13.75,9.375 C14.095,9.375 14.375,9.655 14.375,10 C14.375,10.345 14.095,10.625 13.75,10.625 L10.625,10.625 L10.625,13.75 C10.625,14.095 10.345,14.375 10,14.375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C4.48583333,20 0,15.5141667 0,10 C0,4.48583333 4.48583333,0 10,0 C15.5141667,0 20,4.48583333 20,10 C20,15.5141667 15.5141667,20 10,20 Z M10,1.25 C5.175,1.25 1.25,5.175 1.25,10 C1.25,14.825 5.175,18.75 10,18.75 C14.825,18.75 18.75,14.825 18.75,10 C18.75,5.175 14.825,1.25 10,1.25 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.a223647d18d4410c405242422d235d0e.svg";
export { ForwardRef as ReactComponent };